import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer-container">
            <p>© 2024 L5 OOP ICW Ticket Simulation Control Panel</p>
            <p>Created by S.M.N.N. Wijerathna - 20222001</p>
        </div>
    </footer>
  )
}

export default Footer